import { getAppId } from '@/utils/app-config';

const DEFAULT_HEADERS_URL_PATTERN = /^(https?:\/\/)?([\w-]+\.)*exodus\.io/;

const originalFetch = global.fetch;
type Fetch = typeof originalFetch;

const appId = getAppId();

const defaultHeaders = {
  'x-exodus-app-id': appId,
};

const interceptors: {
  request?: (url: string, init: RequestInit) => RequestInit;
} = {};

const customFetch = (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const url = input instanceof Request ? input.url : input.toString();

  const defaultedHeaders = {
    ...init?.headers,
    ...defaultHeaders,
  };

  const newInit = {
    ...init,
    headers: DEFAULT_HEADERS_URL_PATTERN.test(url)
      ? defaultedHeaders
      : init?.headers,
  };

  return originalFetch(input, interceptors.request?.(url, newInit) ?? newInit);
};

function setDefaultHeader(key: string, value?: string) {
  if (value === undefined) {
    delete defaultHeaders[key];
    return;
  }

  defaultHeaders[key] = value;
}

// This property is lost if `.bind()` is called on fetch as it creates a new object.
// Using prototype doesn't affect this as the new object doesn't have one.
Object.defineProperty(customFetch, 'setDefaultHeader', {
  value: setDefaultHeader,
  writable: false,
});

function setRequestInterceptor(interceptor?: (typeof interceptors)['request']) {
  interceptors.request = interceptor;
}

Object.defineProperty(customFetch, 'setRequestInterceptor', {
  value: setRequestInterceptor,
  writable: false,
});

global.fetch = customFetch as Fetch;
